
import {
    TouchableOpacity,
    Image,
    View
} from "react-native";
import {
    type FeaturedCardProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    useDebouncedDimensions
} from "../../utils";
import {
    ArrowUpRight
} from "lucide-react-native";
import Linear from "../../assets/images/linear.png";

const FeaturedCard = ({
    coverPhotoURL,
    shortContent,
    currentIndex,
    totalCount,
    onPress,
    title
}: FeaturedCardProps) => {
    const {
        windowWidth
    } = useDebouncedDimensions();

    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    return <TouchableOpacity
        onPress={onPress}
        style={[
            stylesheet.container,
            {
                width: windowWidth - spaces.spacingMd * 2,
                height: (windowWidth - spaces.spacingMd * 2) * 1.25,
                borderRadius: radiuses.xl
            }
        ]}
    >
        <Image
            source={{
                uri: coverPhotoURL
            }}
            resizeMode="cover"
            style={[
                stylesheet.image,
                {
                    borderRadius: radiuses.xl
                }
            ]}
        />
        <Image
            source={Linear}
            resizeMode="cover"
            style={[
                stylesheet.linear,
                {
                    borderRadius: radiuses.xl
                }
            ]}
        />
        <View
            style={[
                stylesheet.arrowContainer,
                {
                    backgroundColor: colors.project.gold,
                    borderRadius: radiuses.xs,
                    padding: spaces.spacingSm,
                    right: spaces.spacingXl,
                    top: spaces.spacingXl
                }
            ]}
        >
            <ArrowUpRight
                color={colors.content.text.high}
                size={24}
            />
        </View>
        <View
            style={[
                stylesheet.content,
                {
                    paddingHorizontal: spaces.spacingXl,
                    paddingBottom: spaces.spacingMd,
                    bottom: spaces.spacingXl
                }
            ]}
        >
            <View
                style={[
                    stylesheet.featuredTag,
                    {
                        backgroundColor: colors.content.container.mid,
                        paddingHorizontal: spaces.spacingLg,
                        paddingVertical: spaces.spacingSm,
                        borderRadius: radiuses.actions
                    }
                ]}
            >
                <Text
                    color="high"
                    variant="bodyLargeSize"
                >
                    {localize("featured")}
                </Text>
            </View>
            <Text
                color="onPrimary"
                variant="headlineSmallSize"
                style={{
                    marginTop: spaces.spacingSm
                }}
            >
                {title}
            </Text>
            <Text
                color="onPrimary"
                variant="bodyLargeSize"
                style={{
                    marginTop: spaces.spacingSm
                }}
            >
                {shortContent.length > 100
                    ? `${shortContent.substring(0, 100)}..`
                    : shortContent}
            </Text>
            <View
                style={stylesheet.dotsContainer}
            >
                {Array.from({
                    length: totalCount
                }).map((_, i) => <View
                    key={i}
                    style={[
                        stylesheet.dot,
                        {
                            backgroundColor: currentIndex === i
                                ? colors.content.container.primary
                                : colors.content.container.default,
                            marginHorizontal: spaces.spacingSm,
                            marginVertical: spaces.spacingMd,
                            borderRadius: radiuses.full,
                            width: currentIndex === i ? 43 : 17
                        }
                    ]}
                />)}
            </View>
        </View>
    </TouchableOpacity>;
};
export default FeaturedCard;
